import React from 'react';
import { COLORS_CONSTANTS } from '../../constants/Colors';

/**
 * Card component — pastel glass surface defaults
 */
export default function Card({
  elevation = 1,
  animation = false,
  radius = 36,
  borderColor = COLORS_CONSTANTS.GLASS_BORDER,
  backgroundColor = COLORS_CONSTANTS.GLASS_SURFACE_SOLID,
  backgroundGradientColor1,
  backgroundGradientColor2,
  style = {},
  children,
  onClick
}) {
  const boxShadow = elevation > 0
    ? COLORS_CONSTANTS.GLASS_SHADOW
    : 'none';

  const cardStyle = {
    borderRadius: radius,
    border: `2px solid ${borderColor}`,
    boxShadow,
    backdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
    WebkitBackdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
    background: backgroundGradientColor1 && backgroundGradientColor2
      ? `linear-gradient(180deg, ${backgroundGradientColor1}, ${backgroundGradientColor2})`
      : backgroundColor || COLORS_CONSTANTS.GLASS_SURFACE,
    transition: animation ? 'transform 0.2s cubic-bezier(.25,.8,.25,1), box-shadow 0.2s' : undefined,
    boxSizing: 'border-box',
    ...style,
  };

  return (
    <div
      style={cardStyle}
      className={animation ? 'card-animated' : ''}
      onClick={onClick}
      onMouseEnter={e => {
        if (animation) e.currentTarget.style.transform = 'scale(1.03)';
      }}
      onMouseLeave={e => {
        if (animation) e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      {children}
    </div>
  );
}
